import styled from 'styled-components';
import { Menu, Layout,  Tabs, Form } from 'antd';

const { Sider } = Layout;


export const StyledHomepage = styled.div`
 margin:20px;
`;

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;
export const StyledFloatLeft = styled.div`
  float: left;
`;
export const StyledFloatRight = styled.div`
  float: right;
`;
export const StyledWrapperRight = styled.div`
  margin-left: 1%;
  width: 100%;
  padding: 20px 20px;
`;
export const StyledWrapperLeft = styled.div`
  width: 25%;
  background-color: ${props => props.backgroundColor};
`;
export const StyledMenu = styled(Menu)`
  border-right: 0;
`;
export const StyledSider = styled(Sider)`
`;

export const DrawerFooter = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px 16px 0px;
  text-align: right;
`;


export const StyledContentRight = styled.div`
  display: flex !important;
  justify-content: end !important;
`;
export const StyledTabs = styled(Tabs)`
  .ant-tabs-tab {
    position: relative;
    display: inline-flex;
    align-items: center;
    padding: 12px 0;
    background: transparent;
    border: 0;
    outline: none;
    cursor: pointer;
  }

  .ant-tabs-tab-remove {
    flex: none;
    margin-right: -4px;
    margin-left: 8px;
    background: #1a3b5c;
    border: none;
    outline: none;
    cursor: pointer;
    transition: all 0.3s;
    color: white !important;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${(props) => props.theme.form.tabs.color};
    text-shadow: 0 0 0.25px currentcolor;
  }
`;

export const StyledForm = styled(Form)`
  .ant-divider-horizontal.ant-divider-with-text {
    display: flex;
    margin: 16px 0;
    font-weight: 500;
    white-space: nowrap;
    text-align: center;
    border-top: 0;
  }

  .ant-form-item-label > label {
    color: ${(props) => props.theme.form.formLabel} !important;
    font-weight: revert;
    font-weight: bold;
  }

  .ant-tabs-content-holder {
    border-radius: 0 5px 5px 5px;
  }
`;
